import bootstrap from '@/core/bootstrap';

bootstrap();
